import { useState } from '#imports'
import type { ColorModeInstance } from '@nuxtjs/color-mode/dist/runtime/types'

/**
 * Accès typé au mode clair/sombre Nuxt (`@nuxtjs/color-mode`).
 * Évite de dépendre de l’auto-import `useColorMode`, source de ReferenceError dans certains bundles.
 */
export function useMonOrgaColorMode(): ColorModeInstance {
  return useState<ColorModeInstance>('color-mode').value
}
